import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { Tooltip } from "react-tooltip";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { formatNumberWithCommas } from "@/helpers/Helpers";
interface WaveDropRatingsProps {
  readonly drop: ApiDrop;
}
const WaveDropRatings: React.FC<WaveDropRatingsProps> = t0 => {
  const $ = _c(28);
  const {
    drop
  } = t0;
  let borderStyle = "tw-border-iron-700";
  let bgStyle = "tw-bg-iron-900/40";
  const yourVotes = drop?.context_profile_context?.rating ?? 0;
  const hasVoted = yourVotes !== 0;
  const hasUpvoted = yourVotes > 0;
  if (hasVoted) {
    borderStyle = "tw-border-primary-500";
    bgStyle = "tw-bg-primary-500/10";
  }
  const t1 = `tw-inline-flex tw-items-center tw-gap-x-2 tw-mt-1 tw-py-1 tw-px-2 tw-rounded-lg tw-shadow-sm tw-border tw-border-solid ${borderStyle} ${bgStyle}`;
  let t2;
  if ($[0] !== drop.top_raters) {
    t2 = drop.top_raters.map(_temp);
    $[0] = drop.top_raters;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="tw-flex tw-items-center -tw-space-x-2">{t2}</div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== drop.raters_count) {
    t4 = formatNumberWithCommas(drop.raters_count);
    $[4] = drop.raters_count;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = drop.raters_count === 1 ? "voter" : "voters";
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <span className="tw-text-iron-500 tw-text-xs tw-font-normal">{t4}{" "}{t5}</span>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-x-2">{t3}{t6}</div>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== drop.id || $[13] !== drop.raters_count || $[14] !== drop.rating) {
    t8 = drop.raters_count > 0 && <><span className="tw-text-iron-900 tw-text-xs tw-font-medium tw-bg-iron-500 tw-px-2 tw-py-0.5 tw-rounded-full" data-tooltip-id={`total-rating-${drop.id}`}>{formatNumberWithCommas(drop.rating)}{" "}</span><Tooltip id={`total-rating-${drop.id}`} style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px"
      }}>Total</Tooltip></>;
    $[12] = drop.id;
    $[13] = drop.raters_count;
    $[14] = drop.rating;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== drop.id || $[17] !== hasUpvoted || $[18] !== hasVoted || $[19] !== yourVotes) {
    t9 = hasVoted && <div className={`${hasUpvoted ? "tw-bg-green/20" : "tw-bg-red/20"} tw-ml-2 tw-rounded-full tw-h-4 tw-min-w-4 tw-flex tw-items-center tw-justify-center tw-transition tw-ease-out tw-duration-300`}><><span className={`${hasUpvoted ? "tw-text-green" : "tw-text-error"} tw-text-xs tw-font-normal`} data-tooltip-id={`your-votes-${drop.id}`}>{formatNumberWithCommas(yourVotes)}</span><Tooltip id={`your-votes-${drop.id}`} style={{
          backgroundColor: "#1F2937",
          color: "white",
          padding: "4px 8px"
        }}>Your given likes</Tooltip></></div>;
    $[16] = drop.id;
    $[17] = hasUpvoted;
    $[18] = hasVoted;
    $[19] = yourVotes;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-iron-500 tw-text-xs tw-font-normal">{t8}{t9}</div>;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t1 || $[25] !== t10 || $[26] !== t7) {
    t11 = <div className={t1}>{t7}{t10}</div>;
    $[24] = t1;
    $[25] = t10;
    $[26] = t7;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
export default WaveDropRatings;
function _temp(rater) {
  return <div key={rater.profile.id}>{rater.profile.pfp ? <img src={getScaledImageUri(rater.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${rater.profile.handle}'s avatar`} className="tw-max-h-5 tw-max-w-5 tw-rounded-md tw-ring-black/50 tw-ring-1 tw-bg-iron-700" data-tooltip-id={`rater-${rater.profile.id}`} /> : <div className="tw-h-5 tw-w-5 tw-rounded-md tw-ring-1 tw-ring-black/50 tw-bg-iron-700" data-tooltip-id={`rater-${rater.profile.id}`} />}<Tooltip id={`rater-${rater.profile.id}`} style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>{rater.profile.handle} - {rater.rating}</Tooltip></div>;
}